module.exports = __webpack_public_path__ + "img/syllabus-title-sm.8116ab0a.png";